import type React from "react";
import { useEffect, useRef } from "react";

import styles from "./styles.module.scss";

interface MarkdownEditorPreviewProps {
  value: string;
  onChange: (value: string) => void;
  previewContent: React.ReactNode;
  textareaClassName?: string;
  previewClassName?: string;
  wrapperClassName?: string;
  textareaPlaceholder?: string;
}

const joinClassNames = (...classes: Array<string | undefined | false>): string =>
  classes.filter(Boolean).join(" ");

const MarkdownEditorPreview: React.FC<MarkdownEditorPreviewProps> = ({
  value,
  onChange,
  previewContent,
  textareaClassName,
  previewClassName,
  wrapperClassName,
  textareaPlaceholder,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  }, []);

  return (
    <div className={joinClassNames(styles["wrapper"], wrapperClassName)}>
      <div className={styles["editorPane"]}>
        <textarea
          ref={textareaRef}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          className={joinClassNames(styles["textarea"], textareaClassName)}
          placeholder={textareaPlaceholder}
        />
      </div>
      <div className={styles["previewPane"]}>
        <div className={joinClassNames(styles["previewContent"], previewClassName)}>
          {previewContent}
        </div>
      </div>
    </div>
  );
};

export default MarkdownEditorPreview;
